import { render, staticRenderFns } from "./_refinement-list.vue?vue&type=template&id=f011b212"
import script from "./_refinement-list.vue?vue&type=script&lang=js"
export * from "./_refinement-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports